export default __webpack_public_path__ + "static/media/info-icon.cfe1ad93.svg";